export const COMPARADOR_FUNDOS_BASE_PATH = '/comparador/fundos';
export const COMPARADOR_FUNDOS_QUERY_KEY = 'fundos';
export const COMPARADOR_FUNDOS_MAX_ITEMS = 3;

/**
 * Retorna o benchmark comum quando todos os fundos possuem a mesma referência.
 *
 * @param {Object[]} pFundos Fundos disponíveis para comparação.
 * @returns {string|null} Identificador comum ou null para referências distintas.
 */
export function getComparadorFundosCommonBenchmark(pFundos = []) {
  const xBenchmarkIds = pFundos.map(
    pFundo => pFundo?.indicador_id || pFundo?.benchmarkIndicadorId || null
  );
  const xFirstBenchmarkId = xBenchmarkIds[0];
  const xHasCommonBenchmark =
    Boolean(xFirstBenchmarkId) &&
    xBenchmarkIds.length > 0 &&
    xBenchmarkIds.every(pBenchmarkId => pBenchmarkId === xFirstBenchmarkId);

  return xHasCommonBenchmark ? xFirstBenchmarkId : null;
}

/**
 * Saneia ids por forma, ordem, unicidade e limite.
 *
 * @param {string|string[]} pFundosIds Valor bruto ou lista de ids.
 * @returns {string[]} Lista canônica de ids.
 */
export function normalizeComparadorFundosIds(pFundosIds) {
  const xFundosIds = Array.isArray(pFundosIds) ? pFundosIds : String(pFundosIds || '').split(',');
  const xUniqueIds = [];

  xFundosIds.forEach(pFundoId => {
    const xFundoId = String(pFundoId || '').trim();

    if (
      !/^[1-9]\d*$/.test(xFundoId) ||
      xUniqueIds.includes(xFundoId) ||
      xUniqueIds.length >= COMPARADOR_FUNDOS_MAX_ITEMS
    ) {
      return;
    }

    xUniqueIds.push(xFundoId);
  });

  return xUniqueIds;
}

/** Extrai a seleção canônica da query string. */
export function parseComparadorFundosSearch(pSearch = '') {
  const xParams = new URLSearchParams(pSearch);

  return normalizeComparadorFundosIds(xParams.get(COMPARADOR_FUNDOS_QUERY_KEY));
}

/** Monta a rota canônica preservando a ordem aceita. */
export function buildComparadorFundosPath(pFundosIds = []) {
  const xFundosIds = normalizeComparadorFundosIds(pFundosIds);

  if (xFundosIds.length === 0) {
    return COMPARADOR_FUNDOS_BASE_PATH;
  }

  return `${COMPARADOR_FUNDOS_BASE_PATH}?${COMPARADOR_FUNDOS_QUERY_KEY}=${xFundosIds.join(',')}`;
}
